"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoteEscrowEpochInfoSchema = void 0;
const core_contracts_ifaces_1 = require("@tutellus/core-contracts-ifaces");
const zod_1 = require("zod");
exports.VoteEscrowEpochInfoSchema = zod_1.z.object({
    epochID: zod_1.z.number().int().min(0),
    startDate: zod_1.z.string().datetime(), // ISO 8601
    endDate: zod_1.z.string().datetime(), // ISO 8601
    totalFees: zod_1.z.array(core_contracts_ifaces_1.CurrencyAmountSchema),
    totalIncentives: zod_1.z.array(core_contracts_ifaces_1.CurrencyAmountSchema),
    nextEpochFees: zod_1.z.object({
        total: zod_1.z.array(core_contracts_ifaces_1.CurrencyAmountSchema),
        items: zod_1.z.array(core_contracts_ifaces_1.TokenAmountSchema),
    }),
});
